import baseRoute from '../baseRoute';

export default `${baseRoute}/organizationDocument` as const;
